( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('CompanyCustomService', CompanyCustomService);

    CompanyCustomService.$inject = ['$http'];

    function CompanyCustomService($http) {
        return {
            returnCompaniesByType: returnCompaniesByType,
            returnCompanyByName: returnCompanyByName,
            returnCompanyAuditById: returnCompanyAuditById,
            returnUsedCompanies: returnUsedCompanies,
            returnSearchCompanies: returnSearchCompanies
        };

        function returnSearchCompanies(query) {
            var url = "api/_search/companies?query=" + query;
            return $http.get(url);
        }

        function returnUsedCompanies(contractType, thirdParty) {
            var url = "api/companies/filter?contractType=" + contractType + "&thirdParty=" + thirdParty;
            return $http.get(url);
        }

        function returnCompaniesByType(type) {
            var url = "api/companies/type?type=" + type;
            return $http.get(url);
        }

        function returnCompanyByName(name) {
            var url = "api/companies/name?name=" + name;
            return $http.get(url);
        }

        function returnCompanyAuditById(id) {
            var url = "jv/audit/companies/" + id;
            return $http.get(url);
        }
    }
})();
